import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";

export default class CircleManageIndexRoute extends DiscourseRoute {
  @service router;

  beforeModel() {
    this.router.transitionTo("circle.manage.profile");
  }
}
